import { shoppingCartItemComponentView } from './shopping-cart-item_component.view';
import { Metrics } from '../../metrics';
import { MATOMO_EVENT_NAMES } from '../../metric-events';
import { AppState } from '../../shared/app.state';
import { AppUtils } from '../../utils/app_utils';
import { UrlUtils } from '../../api/urls';
import { ShoppingCartItemBaseComponent } from './shopping-cart-item_base_component';
export class ShopifyShoppingCartItemComponent extends ShoppingCartItemBaseComponent {
    constructor(shoppingCartItems, product, currencyService, shoppingCartService) {
        super(shoppingCartItems, product, currencyService, shoppingCartService);
        this.shoppingCartItems = shoppingCartItems;
        this.product = product;
        this.currencyService = currencyService;
        this.shoppingCartService = shoppingCartService;
    }
    renderItem() {
        this.mainContainer.classList.add('app-shopping-cart-item');
        if (this.product.quantity_available <= 0) {
            this.product.quantity = 0;
            this.mainContainer.classList.add('out-of-stock');
        }
        const shoppingCartItemContainer = document.createElement('div');
        this.mainContainer.append(shoppingCartItemContainer);
        this.productName = UrlUtils.slugify(this.product.title);
        shoppingCartItemContainer.outerHTML = shoppingCartItemComponentView(this.product, this.getProductPrice());
        this.updateDisableState();
        if (this.product.per_order_limit && this.overallQuantity > this.product.per_order_limit) {
            this.mainContainer.classList.add('limit-error');
        }
        return this.mainContainer;
    }
    changeQuantity(el) {
        var _a, _b, _c, _d;
        const operation = el.classList.contains('app-shopping-cart-item-increase') ? 'increase' : 'decrease';
        const currQuantity = this.product.quantity;
        switch (operation) {
            case 'increase': {
                if (this.overallQuantity + 1 <= this.product.quantity_available) {
                    if (((_a = this.product) === null || _a === void 0 ? void 0 : _a.per_order_limit) && this.overallQuantity + 1 > ((_b = this.product) === null || _b === void 0 ? void 0 : _b.per_order_limit)) {
                        return;
                    }
                    this.product.quantity += 1;
                    Metrics.storeTheEvent(AppState.planogramName, 'click', MATOMO_EVENT_NAMES.CLICK_SHOPPING_CART_OVERLAY_INCREASE_ITEM_QUANTITY((_c = this.product) === null || _c === void 0 ? void 0 : _c.product_id, this.productName));
                    this.shoppingCartItems.updateShoppingCart(this.product);
                }
                break;
            }
            case 'decrease': {
                if (currQuantity - 1 >= 1) {
                    this.product.quantity -= 1;
                    Metrics.storeTheEvent(AppState.planogramName, 'click', MATOMO_EVENT_NAMES.CLICK_SHOPPING_CART_OVERLAY_DECREASE_ITEM_QUANTITY((_d = this.product) === null || _d === void 0 ? void 0 : _d.product_id, this.productName));
                    this.shoppingCartItems.updateShoppingCart(this.product);
                }
                break;
            }
        }
        this.updateDisableState();
    }
    updateDisableState() {
        var _a, _b;
        const increaseButton = this.mainContainer.querySelector('.app-shopping-cart-item-increase');
        const decreaseButton = this.mainContainer.querySelector('.app-shopping-cart-item-decrease');
        this.countOverallQuantity();
        if (increaseButton) {
            (((_a = this.product) === null || _a === void 0 ? void 0 : _a.per_order_limit) && this.overallQuantity >= ((_b = this.product) === null || _b === void 0 ? void 0 : _b.per_order_limit)) ||
                this.overallQuantity >= this.product.quantity_available
                ? increaseButton.classList.add('disabled')
                : increaseButton.classList.remove('disabled');
        }
        if (decreaseButton) {
            this.product.quantity <= 1
                ? decreaseButton.classList.add('disabled')
                : decreaseButton.classList.remove('disabled');
        }
    }
    deleteItem() {
        var _a;
        Metrics.storeTheEvent(AppState.planogramName, 'click', MATOMO_EVENT_NAMES.CLICK_SHOPPING_CART_OVERLAY_REMOVE_PRODUCT((_a = this.product) === null || _a === void 0 ? void 0 : _a.product_id, this.productName));
        this.shoppingCartItems.removeItemFromCart(this.product);
    }
    countOverallQuantity() {
        var _a;
        this.overallQuantity = AppUtils.overallQuantity(this.shoppingCartService.shoppingCart, this.product, (_a = this.product) === null || _a === void 0 ? void 0 : _a.per_order_limit);
    }
}
